import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import api from "@/lib/api";

export default function WhatsAppFloat() {
  const [wa, setWa] = useState(null);
  useEffect(() => { api.get("/site-settings").then((r) => setWa(r.data.whatsapp)).catch(() => {}); }, []);
  if (!wa || !wa.enabled || !wa.number) return null;
  const num = wa.number.replace(/[^0-9]/g, "");
  const href = `https://wa.me/${num}?text=${encodeURIComponent(wa.message || "Bonjour TOGOBATI")}`;
  return (
    <a href={href} target="_blank" rel="noreferrer" aria-label="Contacter sur WhatsApp"
       data-testid="whatsapp-float"
       className="fixed bottom-5 right-5 z-50 w-14 h-14 rounded-full bg-[#25D366] shadow-lg shadow-[#25D366]/40 flex items-center justify-center hover:scale-105 active:scale-95 transition-transform">
      <MessageCircle className="w-7 h-7 text-white" fill="white" />
      <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-40 animate-ping" />
    </a>
  );
}
